import React from 'react';

type ArrowIconProps = {
  className?: string;
};
const ArrowIcon = ({ className = '' }: ArrowIconProps) => (
  <svg
    className={className}
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.55877 0.0919999L12.9588 5.762L7.55877 11.432L6.35277 10.208L10.0428 6.554H0.0347656V4.97H10.0428L6.35277 1.316L7.55877 0.0919999Z"
      fill="#323232"
    />
  </svg>
);

export default ArrowIcon;
